<template>
    <div class="baoxiu_list">
        <section>
          <li class="baoxiu_item" v-for="(item, ind) in list" :key="ind" >
            <p class="baoxiu_flex">
                <span>
                    姓名：{{$formatName(item.userName)}}
                </span>

                <span  v-if="item.status==2" @click="goPj(item.ordersn, item.taskId)" class="goPj">
                    去评价
                    <i class="el-icon-right"></i>
                </span>
              <span  v-if="item.status==4" >
                   评价：{{item.satisfy}}
                </span>
            </p>
            <p></p>
            <p class="baoxiu_flex">
                <span>
                    报修类型：{{item.taskType}}
                </span>
              <span>
                    报修状态：{{getValue(item.status)}}
                </span>
            </p>

            <p class="baoxiu_flex">
                <span>报修时间：{{item.createTime}}
                </span>
                <span>
                    来源：{{item.category}}
                </span>
            </p>
            <p>
              地址：{{item.address}}
            </p>
          </li>
          <p class="no_data" v-if="!list.length">
            暂无报修记录
          </p>
        </section>
        <footer>
          <button class="btn_bx" @click="goBx" type="primary">申 请 报 修</button>
        </footer>

    </div>
</template>

<script>
import { baoxiuList } from '@/api'
export default {
    data() {
        return {
            list: [],
            value: '',
            taskTypeOptioon:[
              {value:'报修',label:'报修'},
              {value:'投诉',label:'投诉'},
              {value:'建议',label:'建议'},
              {value:'测温',label:'测温'},
            ],
          form:{
            taskType:''
          },
          rules:{}
        }
    },
    mounted() {
      this.getList()
    },
    methods: {
        getList(){
          let params = {
            openId: sessionStorage.getItem('thirdId'),
            taskType: this.form.taskType,
            userCode: this.$route.query.code
          }
          baoxiuList(params).then(res=> {
            this.list = res.data
          })
        },
        getValue(status) {
            let arr = ['待处理', '处理中', '待评价','', '已完成']
            return arr[status]
        },
        goPj(ordersn, taskId) {
            this.$router.push({
                path: `/pj/${taskId}`
            })
        },
      goBx() {
        this.$router.push({
          path: '/baoxiu',
          query: {...this.$route.query,type: 1}
        })
      }
    }
}
</script>

<style scoped>

 .baoxiu_list{
   display:-webkit-box;
   display:-webkit-flex;
   display:-ms-flexbox;
   display:flex;
   -webkit-box-orient:vertical;
   -webkit-flex-direction:column;
   -ms-flex-direction:column;
   flex-direction:column;
   width:100%;
   height:90%;
 }
 .demo-ruleForm{
   margin-top: 5px;
   margin-left: 10px;
 }
 .btn_bx{
   width: 94%;
   margin-left: 3%;
   /*margin-top: 3rem;*/
   font-size: 1rem;
   height: 2.5rem;
   background: #47c34d;
   border-radius: 3px;
 }
 header,footer{
   height:40px;
   line-height: 40px;

   /*text-align:center;*/
 }
 header{
   margin-bottom: 5px;
   background-color:#fff;

 }
 section{
   -webkit-box-flex:1;
   -webkit-flex:1;
   -ms-flex:1;
   flex:1;
   width:100%;
   overflow:auto;/* winphone8和android4+ */
   -webkit-overflow-scrolling: touch; /* ios5+ */
 }

.baoxiu_item{
    border-bottom: 5px solid #f1f1f1;
    padding: 3%;
    line-height: 25px;
     background: #fff;
}
.baoxiu_flex{
    display: flex;
    justify-content: space-between;
}
.goPj{
    color: #1890ff;
}

</style>



// WEBPACK FOOTER //
// src/view/ywbl/bx/baoxiuList.vue